import { useCreateStateV2MCMutation } from "../../core/api/mc-state-api"
import {
    useGetSyncConflictMCQuery,
    useGetSyncConflictsMCQuery
} from "../../core/api/mc-sync-conflicts-api"
import SyncConflictsPage from "./SyncConflictsPage"

export default function SyncConflictsMC({ game = "mc" }) {
    const [createState, createStateResult] = useCreateStateV2MCMutation()

    return (
        <SyncConflictsPage
            game={game}
            useListQuery={useGetSyncConflictsMCQuery}
            useDetailQuery={useGetSyncConflictMCQuery}
            createState={createState}
            createStateResult={createStateResult}
        />
    )
}
